import React from 'react';

import Icons from 'assets/icons';

import { Box } from 'ui/box';

interface QuoteProps {
  text?: string;
  author?: string;
}

const Quote = ({ text, author }: QuoteProps): React.JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      bgcolor: 'tokens.blue.100',
      p: 3,
      borderRadius: '0.375rem',
      '@media (min-width: 375px)': { flexDirection: 'column', mb: 3 },
      '@media (min-width: 780px)': { flexDirection: 'row' },
      '@media (min-width: 960px)': { mb: 4 },
    }}
  >
    <Box sx={{ width: '3rem', height: '2rem' }}>
      <Icons.QuoteMark width={28} height={32} />
    </Box>
    <Box
      sx={{
        '@media (min-width: 375px)': { pt: 1 },
        '@media (min-width: 780px)': { pt: 0, pl: 2 },
      }}
    >
      <Box
        sx={{
          fontWeight: 600,
          fontSize: '1.125rem',
          lineHeight: '1.75rem',
          color: 'tokens.blue.800',
        }}
      >
        {text}
      </Box>
      <Box
        sx={{
          fontStyle: 'italic',
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          color: 'tokens.blue.800',
          pt: 2,
        }}
      >
        {author}
      </Box>
    </Box>
  </Box>
);

export default Quote;
